import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { SignatureV4S3Express } from "@aws-sdk/middleware-sdk-s3";
import { signatureV4CrtContainer } from "./signature-v4-crt-container";
export var SignatureV4MultiRegion = /*#__PURE__*/function () {
  function SignatureV4MultiRegion(options) {
    _classCallCheck(this, SignatureV4MultiRegion);
    this.sigv4Signer = new SignatureV4S3Express(options);
    this.signerOptions = options;
  }
  _createClass(SignatureV4MultiRegion, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestToSign) {
        var options,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                if (!(options.signingRegion === "*")) {
                  _context.next = 5;
                  break;
                }
                if (!(this.signerOptions.runtime !== "node")) {
                  _context.next = 4;
                  break;
                }
                throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
              case 4:
                return _context.abrupt("return", this.getSigv4aSigner().sign(requestToSign, options));
              case 5:
                return _context.abrupt("return", this.sigv4Signer.sign(requestToSign, options));
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function sign(_x) {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }, {
    key: "signWithCredentials",
    value: function () {
      var _signWithCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestToSign, credentials) {
        var options,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                if (!(options.signingRegion === "*")) {
                  _context2.next = 5;
                  break;
                }
                if (!(this.signerOptions.runtime !== "node")) {
                  _context2.next = 4;
                  break;
                }
                throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
              case 4:
                return _context2.abrupt("return", this.getSigv4aSigner().signWithCredentials(requestToSign, credentials, options));
              case 5:
                return _context2.abrupt("return", this.sigv4Signer.signWithCredentials(requestToSign, credentials, options));
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function signWithCredentials(_x2, _x3) {
        return _signWithCredentials.apply(this, arguments);
      }
      return signWithCredentials;
    }()
  }, {
    key: "presign",
    value: function () {
      var _presign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(originalRequest) {
        var options,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                if (!(options.signingRegion === "*")) {
                  _context3.next = 5;
                  break;
                }
                if (!(this.signerOptions.runtime !== "node")) {
                  _context3.next = 4;
                  break;
                }
                throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
              case 4:
                return _context3.abrupt("return", this.getSigv4aSigner().presign(originalRequest, options));
              case 5:
                return _context3.abrupt("return", this.sigv4Signer.presign(originalRequest, options));
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function presign(_x4) {
        return _presign.apply(this, arguments);
      }
      return presign;
    }()
  }, {
    key: "presignWithCredentials",
    value: function () {
      var _presignWithCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(originalRequest, credentials) {
        var options,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                if (!(options.signingRegion === "*")) {
                  _context4.next = 3;
                  break;
                }
                throw new Error("Method presignWithCredentials is not supported for [signingRegion=*].");
              case 3:
                return _context4.abrupt("return", this.sigv4Signer.presignWithCredentials(originalRequest, credentials, options));
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function presignWithCredentials(_x5, _x6) {
        return _presignWithCredentials.apply(this, arguments);
      }
      return presignWithCredentials;
    }()
  }, {
    key: "getSigv4aSigner",
    value: function getSigv4aSigner() {
      if (!this.sigv4aSigner) {
        var CrtSignerV4 = null;
        try {
          CrtSignerV4 = signatureV4CrtContainer.CrtSignerV4;
          if (typeof CrtSignerV4 !== "function") throw new Error();
        } catch (e) {
          e.message = "".concat(e.message, "\n") + "Please check whether you have installed the \"@aws-sdk/signature-v4-crt\" package explicitly. \n" + "You must also register the package by calling [require(\"@aws-sdk/signature-v4-crt\");] " + "or an ESM equivalent such as [import \"@aws-sdk/signature-v4-crt\";]. \n" + "For more information please go to " + "https://github.com/aws/aws-sdk-js-v3#functionality-requiring-aws-common-runtime-crt";
          throw e;
        }
        this.sigv4aSigner = new CrtSignerV4(_objectSpread(_objectSpread({}, this.signerOptions), {}, {
          signingAlgorithm: 1
        }));
      }
      return this.sigv4aSigner;
    }
  }]);
  return SignatureV4MultiRegion;
}();